import { client } from '@/services/api/axios.ts';
import { QueryClient, useMutation } from '@tanstack/react-query';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';
import toast from 'react-hot-toast';

export const useDeletePlantQuery = ({ queryClient }: { queryClient: QueryClient }) => {
  return useMutation({
    mutationFn: async ({ plantId }: { plantId: string }) => {
      const { data } = await toast.promise(
        async () => await client.delete<{ body: TPlant }>(`/plants/${plantId}`),
        {
          loading: 'Deleting plant...',
          success: () => {
            return 'Successfully deleted the plant.';
          },
          error: (_: unknown) => {
            return `Uh oh, there was an error with deleting the plant.`;
          },
        }
      );

      return data?.body;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['plants'] });
    },
  });
};
